import {
  createTextFilterMeta,
} from '#/modules/commonComponents/table/columnFilterMeta';
import { renderEntityStatusBadge } from '#/modules/commonComponents/table/entityStatusIconHelpers';
import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';

/**
 * BomPickerDialog 用欄（無導航連結）。
 */
export function buildBomPickerColumns({
  filters = {},
  onFilterChange,
} = {}) {
  return [
    {
      header: 'BOM代號',
      accessorKey: 'code',
      size: 120,
      enableColumnFilter: true,
      meta: createTextFilterMeta({
        key: 'code',
        label: 'BOM代號',
        filterValue: filters.code,
        onChange: (value) => onFilterChange('code', value),
        placeholder: '搜尋代號',
      }),
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.code || '—'} />
      ),
    },
    {
      header: 'BOM名稱',
      accessorKey: 'name',
      size: 200,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'name',
          label: 'BOM名稱',
          filterValue: filters.name,
          onChange: (value) => onFilterChange('name', value),
          placeholder: '搜尋名稱',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.name || '—'} />
      ),
    },
    {
      header: '版本',
      accessorKey: 'version',
      size: 96,
      enableColumnFilter: true,
      meta: createTextFilterMeta({
        key: 'version',
        label: '版本',
        filterValue: filters.version,
        onChange: (value) => onFilterChange('version', value),
        placeholder: '搜尋版本',
      }),
    },
    {
      id: 'status',
      header: '狀態',
      accessorKey: 'status',
      size: 88,
      enableColumnFilter: false,
      cell: ({ row }) => renderEntityStatusBadge(row.original.status),
    },
  ];
}
